var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertaSucessoVerdeEscuro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2075 5.94834L8.16665 11.9892L4.87581 8.70751L3.58331 10L8.16665 14.5833L15.5 7.25001L14.2075 5.94834ZM9.99998 0.833344C4.93998 0.833344 0.833313 4.94001 0.833313 10C0.833313 15.06 4.93998 19.1667 9.99998 19.1667C15.06 19.1667 19.1666 15.06 19.1666 10C19.1666 4.94001 15.06 0.833344 9.99998 0.833344ZM9.99998 17.3333C5.94831 17.3333 2.66665 14.0517 2.66665 10C2.66665 5.94834 5.94831 2.66668 9.99998 2.66668C14.0516 2.66668 17.3333 5.94834 17.3333 10C17.3333 14.0517 14.0516 17.3333 9.99998 17.3333Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaSucessoVerdeEscuro);
export default __webpack_public_path__ + "static/media/alerta_sucesso_verde_escuro.bd9c53a5faf7378f4bdee6efc455c814.svg";
export { ForwardRef as ReactComponent };